import { FC, ReactElement } from 'react';

interface IValueSignProps {
  value?: string | ReactElement;
  color?: string;
  colorNumber?: string;
  width?: string;
  height?: string;
  gap?: string;
  containerClassName?: string;
  signClassName?: string;
}

const ValueWithSign: FC<IValueSignProps> = ({
  value,
  color = null,
  colorNumber = null,
  width = '8px',
  height = '8px',
  gap = '10px',
  containerClassName = '',
}) => {
  return (
    <div className={`flex items-start gap-[${gap}] text-left ${containerClassName}`}>
      <div
        style={{
          minWidth: width,
          minHeight: height,
          maxWidth: width,
          maxHeight: height,
          backgroundColor: colorNumber ?? '',
        }}
        className={`${color} rounded-full flex-shrink-0 mt-[4px]`}
      />
      <span className="leading-tight">{value}</span>
    </div>
  );
};

export default ValueWithSign;
